import { TaskStatus } from '@nexelem/graphne-api';
import { NodeType, TimelineNode } from '../types';
import { useGetSimulationStatus } from '../../GanttSimulation/hooks/useGetSimulationStatus';
import { useAuthContext } from '../../../../../providers/AuthProvider';
import { PERMS } from '../../../../../routes/permissions';

const draggableStatuses: TaskStatus[] = [TaskStatus.Pending, TaskStatus.Error];

export const isGanttNodeDraggable = (node: TimelineNode) =>
  (node.type === NodeType.TASK || node.type === NodeType.BATCH) && draggableStatuses.includes(node.status);

export const useIsGanttNodeDraggable = (node: TimelineNode) => {
  const { disableActions } = useGetSimulationStatus();
  const { hasPermission } = useAuthContext();
  const canEditPlan = hasPermission(PERMS.PERM_4);

  return isGanttNodeDraggable(node) && !disableActions && canEditPlan;
};
